const region = "us-east-1";
const origin = window.location.origin;

const demo = {
  appSettingsData: {
    // generate a file format limit of video file
    federatedEngageAIProvider: "wl-dev-lc-production-ident-prov",
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: region,
      userPoolId: "us-east-1_jjbZ99nbA",
      userPoolWebClientId: "7nqdu8bg7mj35t7nhohb198s9g",
    },
    oauth: {
      domain: "wl-stg-logostore.auth.us-east-1.amazoncognito.com",
      scope: [],
      redirectSignIn: `${origin}/live`,
      redirectSignOut: `${origin}/live`,
      responseType: "code",
      clientId: "7nqdu8bg7mj35t7nhohb198s9g",
    },
    API: {
      endpoints: [
        {
          name: "logoCloud",
          // endpoint: "https://api.dev.wl-dms.com",
          endpoint: "https://api.dev.production.wl-logocloud.com",
          region: region,
        },
      ],
    },
  },
};
// type demoType = typeof demo

export type DemoType = typeof demo;
export default demo;
